import { ColumnConfig } from '@/components/table/Table';

export const servicesTableColumns: ColumnConfig[] = [
  { label: 'Nombre', field: 'name' },
  {
    label: 'Tipo de servicio',
    field: 'serviceType',
    render: (value) => value?.name || 'N/A',
  },
  {
    label: 'Tipo de vehículo',
    field: 'vehicleType',
    render: (value) => value?.name || 'N/A',
  },
  {
    label: 'Negocio',
    field: 'commercialBusiness',
    render: (value) => value?.name || 'N/A',
  },
  {
    label: 'Tarifa',
    field: 'fee',
    render: (value) => typeof value === 'number' ? `$${value.toFixed(2)}` : value,
  },
  {
    label: 'Mínimo',
    field: 'min',
    render: (value) => typeof value === 'number' ? value.toString() : value,
  },
  {
    label: 'Vigencia',
    field: 'validFrom',
    render: (_value, rowData) => {
      const from = rowData.validFrom
        ? new Date(rowData.validFrom).toLocaleDateString('es-UY')
        : 'N/A';
      const to = rowData.validTo
        ? new Date(rowData.validTo).toLocaleDateString('es-UY')
        : 'N/A';
      return `${from} - ${to}`;
    },
  },
];
